import * as types from "./mtypes";

export default {
  [types.REQUEST_HANDLER](state) {
    state.loading = true;
  },

  [types.REQUEST_SUCCESS](state, data) {
    state.loading = false;
    state.isLogged = true;
    state.isSucceeded = true;
    state.userName = data.data.userName;
    state.token = data.data.token;
    state.phone = data.data.phone;
    state.email = data.data.email;
    state.permissions = data.data.permissions;
  },

  [types.REQUEST_FAILURE](state, data) {
    state.loading = false;
    state.isSucceeded = data.succeeded;
    state.errorCode = data.errorCode;
    state.errorMessage = data.errorMessage;
    state.validationErrors = data.validationErrors;
    state.isLogged = false;
  },

  [types.AUTH_LOGOUT](state) {
    state.isLogged = false;
    state.isSucceeded = null;
    state.token = "";
    state.userName = "";
    state.phone = "";
    state.email = "";
    state.permissions = [];
  },
};
